import { StyleSheet } from 'react-native';
import { SEPARATOR_STROKE} from '../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
import ResponsiveDimensionValues from '../../components/common/responsive-dimension-values';

export default MediaQueryStyleSheet.create({
  mainWrapper: {
  	flex: 1,
    marginTop: 10,
  }
});
